import { render, staticRenderFns } from "./CadastrarServico.vue?vue&type=template&id=aa4afe8e"
import script from "./CadastrarServico.vue?vue&type=script&lang=js"
export * from "./CadastrarServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports